<template>
<div class="home"></div>
</template>

<script>
import Vue from 'vue';
import Component from 'vue-class-component';

@Component()
export default class Home extends Vue {
  goToFirstLocationInterval = null;

  created () {
    this.goToFirstLocationInterval = setInterval(() => this.goToFirstLocation(), 1000);
  }

  goToFirstLocation () {
    const locations = this.$store.getters['entities/Location/all']();
    if (locations.length) {
      clearInterval(this.goToFirstLocationInterval);
      this.$router.push({ name: 'overview', params: { locationId: locations[0].id } });
    }
  }
}
</script>

<style lang="postcss" scoped>
@import 'core/shared/styles';
</style>
